import React, { Component } from "react";
import PropTypes from "prop-types";

class Radio extends Component {
	constructor(props) {
		super(props);

		this.state = {
			options: props.options,
			name:
				"input-" +
				Math.random()
					.toString(32)
					.substr(2, 5)
		};

		this.handleChange = this.handleChange.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ options: nextProps.options });
	}

	handleChange(e) {
		const item = e.target.value;
		let self = this;

		this.setState({
			options: this.state.options.filter(val => {
				val.checked = false;

				if (val.value == item) {
					val.checked = true;
					// OnChange
					self.props.onChange(val);
				}
				return val;
			})
		});
	}

	render() {
		const { errorMessage } = this.props;
		let mountedOptions = [];
		let dataAction = this.props.hasOwnProperty("data-action")
			? this.props["data-action"]
			: "radio-offers";

		this.state.options.forEach(({label, checked, smallDescription, value}, index) => {
			mountedOptions.push(
				<label key={index} className="radio-component__container">
					{label}
					<small>{smallDescription && smallDescription}</small>
					<input
						className="radio-component__container--input"
						type="radio"
						checked={checked}
						name={this.props.name || this.state.name}
						value={value}
						onChange={this.handleChange}
					/>
					<span className="radio-component__container--span" />
				</label>
			);
		});

		return (
			<div
				className="radio-component"
				style={{ flexDirection: this.props.horizontally ? "row" : "column" }}
				data-action={dataAction}
			>
				{mountedOptions}
				{errorMessage != undefined && errorMessage ? (
					<p className="text-left radio-invalid">{errorMessage}</p>
				) : null}
			</div>
		);
	}
}

Radio.propTypes = {
	options: PropTypes.array.isRequired,
	onChange: PropTypes.func,
	horizontally: PropTypes.bool
};

Radio.defaultProps = {
	horizontally: false
};

export default Radio;
